module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontmatter",
    attrs: {
      "title": "Don’t Squat with Your Spurs On Vol. 2"
    }
  }, [_c('div', {
    staticClass: "recto"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "d0e2"
    }
  }, [_vm._v("Don’t Squat with Your Spurs On Vol. 2")])]), _c('a', {
    attrs: {
      "id": "d0e2"
    }
  }, [_c('h2', [_vm._v("A Cowboy’s Guide to Life")]), _vm._v(" "), _c('h3', [_vm._v("Texas Bix Bender")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Gibbs Smith Logo",
      "src": "images/logo.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "d0e2"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773d36f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recto.vue
// module id = 63
// module chunks = 0